import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { transactionRefetchQueries1 } from '~/modules/billing-invoicing/bill/components/BillDetails/components/hooks/useTransactionRefetchQueries';

const DELETE_BILL_PAYMENT = gql`
  mutation deleteBillPayment($id: String!) {
    deleteBillPayment2(id: $id)
  }
`;

export const useDeleteBillPayment = () => {
  const [deleteBillPayment] = useMutation(DELETE_BILL_PAYMENT);

  return {
    deleteBillPayment: ({ id }) =>
      deleteBillPayment({
        variables: {
          id
        },
        refetchQueries: [...transactionRefetchQueries1],
        awaitRefetchQueries: true
      })
  };
};

export default useDeleteBillPayment;
